import {PayloadAction} from "@reduxjs/toolkit";
import {addCardActions, AddImagePayload} from "../addCard.slice";
import {select, put} from 'redux-saga/effects';
import {RootState} from "../../../store/rootReducer";

// Используем более безопасный подход с типизацией для работы с redux-saga
export function* addImageSaga(action: PayloadAction<AddImagePayload>) {
    // Используем отдельные вызовы select для каждого поля, чтобы избежать проблем с типизацией
    const markup: string = yield select((state: RootState) => state.addCard.markup);
    const images: Record<string, string> = yield select((state: RootState) => state.addCard.images);

    const allIds = Object.keys(images).map(key => parseInt(key));
    const maxImageId = allIds.length > 0 ? Math.max(...allIds) : -1;
    const newImageId = maxImageId + 1;
    const newMarkup = markup.slice(0, action.payload.cursorPosition)
        + `{image-${newImageId}}\n`
        + markup.slice(action.payload.cursorPosition);

    yield put(addCardActions.putImage({
        imageId: newImageId,
        dataUrl: action.payload.dataUrl,
    }))
    yield put(addCardActions.setMarkup(newMarkup));
}
